// extracted by mini-css-extract-plugin
export default {"sendButton":"accountManagement_sendButton__XEg7D","buttonWithDate":"accountManagement_buttonWithDate__PAKdt"};